import PropTypes from 'prop-types'
import { useEffect, useState, useContext, useMemo } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import { toast } from 'react-toastify'
import {
  ID_ESTADO_PERCEPCIONES_OK,
  ID_ESTADO_PERCEPCIONES_NO_OK
} from '../../constants/pedidoEstados'
import { validarRangoFechas } from '../../helpers/dateValidation'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { CarritoContext } from '../context/carritoContext'
import { LoginContext } from '../context/loginContext'
import { calcularTotalItemConIva, calcularTotalItemSinIva } from '../helpers/calcularPrecioTotal'
import FormInsertDomicilio from '../perfil/FormInsertDomicilio'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import * as archivoService from '../servicios/archivoAdjuntoService'
import * as carritoService from '../servicios/carritoService'
import * as compraService from '../servicios/compraService'
import * as datosFiscalesService from '../servicios/datosFiscalesService'
import * as domiciliosService from '../servicios/domiciliosService'
import * as fetchProvinciasAPI from '../servicios/fetchProvinciasAPI'
import * as impuestoService from '../servicios/impuestoService'
import * as listaEnvioService from '../servicios/listaEnvioService'
import { insertarMail } from '../servicios/mailsServices'
import * as mensajesService from '../servicios/mensajesService'
import { recibirUserInfo } from '../servicios/mercadoPagoService'
import * as publicacionesService from '../servicios/publicacionesService'
import BordePrincipal from '../ui/BordePrincipal'
import Comprobante from './Comprobante'
import { DetallePrecio } from './DetallePrecio'
import styles from './Vendedor.module.css'

const ENVIO_DOMICILIO = 1
const RETIRA_COMPRADOR = 2
const ENVIO_A_CARGO_COMPRADOR = 3
const CTA_CTE = 6
const MERCADO_PAGO = 7
const NOT_AUTHORIZED = 401
const INSCRIPTO = 1
const EXENTO = 3
const ESTADO_PAGO_PENDIENTE = 7
const ESTADO_PEDIDO_CREADO = 8
const ALICUOTA_PERCEPCION = 3
const ALICUOTA_MAX = 4
const ID_BUENOS_AIRES = 1
const ID_CABA = 5
const ID_ENTRE_RIOS = 8
const ID_JUJUY = 10
const PADRONES_PROVINCIAS = [ID_CABA, ID_BUENOS_AIRES, ID_ENTRE_RIOS, ID_JUJUY]
const PAGO_EN_CTA_CTE = 3
const ALIAS_CABA = [
  'caba',
  'capital federal',
  'ciudad autonoma de buenos aires',
  'ciudad de buenos aires',
  'cap fed'
]

const Vendedor = ({ vendedor }) => {
  const selectMenuPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
  }

  const [domicilios, setDomicilios] = useState([])
  const [verModalDatosEnvio, setVerModalDatosEnvio] = useState(false)
  const [verComprobante, setVerComprobante] = useState(false)
  const [pedidos, setPedidos] = useState([])
  const [idMedioEnvio, setIdMedioEnvio] = useState({})
  const [mediosPago, setMediosPago] = useState([])
  const [medioPagoSeleccionado, setMedioPagoSeleccionado] = useState({})
  const [mediosEnvios, setMediosEnvio] = useState([])
  const [listasEnvio, setListasEnvio] = useState({})
  const [listaEnvioSeleccionada, setListaEnvioSeleccionada] = useState({})
  const [verModalNuevoDomicilio, setVerModalNuevoDomicilio] = useState(false)
  const [provinciasAPI, setProvinciasAPI] = useState([])
  const [domicilioPrincipal, setDomicilioPrincipal] = useState(false)
  const [domicilioFacturacion, setDomicilioFacturacion] = useState(false)
  const [datosFiscalesComprador, setDatosFiscalesComprador] = useState([])
  const [datosFiscalesVendedor, setDatosFiscalesVendedor] = useState([])
  const [domiciliosVendedor, setDomiciliosVendedor] = useState([])
  const [direccionEntrega, setDireccionEntrega] = useState({})
  const [percepciones, setPercepciones] = useState([])
  const [alicuota, setAlicuota] = useState([])

  const { loginDataContext } = useContext(LoginContext)
  const { idUsuario, cuit, tipoUsuario } = loginDataContext

  const pedidoCompletoEsCtaCte = useMemo(() => {
    const ids = (vendedor.pedidoItems ?? []).map((i) => i.idPublicacion)

    const todosSeleccionados = ids.every((id) => medioPagoSeleccionado[id] !== null)

    if (!todosSeleccionados) {
      return false
    }
    return ids.every((id) => Number(medioPagoSeleccionado[id]) === CTA_CTE)
  }, [medioPagoSeleccionado, vendedor.pedidoItems])

  const obtenerAlicuotaPercepcion = async () => {
    const { data } = await impuestoService.obtenerAlicuota(cuit)
    if (!Array.isArray(data) || data.length === 0) {
      setAlicuota(null)
      return
    }
    const alicuotaData = data.map((d) => {
      const alicuotaNormalizada =
        typeof d.alicuotaPadron === 'string'
          ? parseFloat(d.alicuotaPadron.replace(',', '.'))
          : Number(d.alicuotaPadron)
      return {
        alicuotaPadron: alicuotaNormalizada,
        idProvincia: d.idProvincia,
        nombreProvincia: d.nombreProvincia
      }
    })
    setAlicuota(alicuotaData)
  }

  const handleAbrirModalNuevoDomicilio = () => {
    setVerModalNuevoDomicilio(true)
    setDomicilioPrincipal(false)
    setDomicilioFacturacion(false)
  }

  const handleGuardarNuevoDomicilio = async (nuevoDomicilio) => {
    try {
      const { data } = await domiciliosService.insertar(nuevoDomicilio)
      if (data.idUsuarioDomicilio) {
        const idUsuario = parseInt(localStorage.getItem('idUsuario'))
        const { data: domiciliosActualizados } = await domiciliosService.buscarTodas(
          idUsuario,
          tipoUsuario
        )

        setDomicilios(domiciliosActualizados)

        setVerModalNuevoDomicilio(false)
        toast('Domicilio agregado exitosamente')
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al guardar el domicilio.`
      toastErrorLog(error, mensaje, 'domicilio')
    }
  }

  const handleChangeDomicilio = (e) => {
    const { name, checked } = e.target
    if (name === 'domicilioPrincipal') {
      setDomicilioPrincipal(checked)
    } else if (name === 'domicilioFacturacion') {
      setDomicilioFacturacion(checked)
    }
  }

  const navigate = useNavigate()

  const { setCantidad, setItems, items } = useContext(CarritoContext)

  const [chktyc, setChktyc] = useState(null)
  const [error, setError] = useState('')
  const [tycfile, setTycfile] = useState(null)

  const obtenerMediosDePago = async () => {
    let mediosPagoValidos = []
    const { data } = await publicacionesService.BuscarMediosDePago(0)
    try {
      mediosPagoValidos = data
      await recibirUserInfo({ idVendedor: vendedor.idVendedor })
    } catch (error) {
      if (error?.response?.status === NOT_AUTHORIZED) {
        mediosPagoValidos = data.filter((m) => m.idMedioPago !== MERCADO_PAGO)
      }
    }

    setMediosPago(mediosPagoValidos.map((m) => ({ value: m.idMedioPago, label: m.nombre })))
  }

  const obtenerMediosEnvio = async () => {
    const { data } = await publicacionesService.buscarMedioEnvio()
    setMediosEnvio(data.map((m) => ({ value: m.idMedioEnvio, label: m.nombre })))
  }

  const obtenerListasEnvioDelVendedor = async () => {
    const listasEnvioPorProducto = {}

    for (const item of vendedor.pedidoItems) {
      const { data } = await listaEnvioService.buscarListaPorVendedor(
        vendedor.idVendedor,
        item.idPublicacion
      )
      const listasValidas = data.filter((lista) => {
        if (!validarRangoFechas(new Date(), lista.vigenciaHasta)) {
          return false
        }

        if (!lista.grilla || lista.grilla.length === 0) {
          return false
        }

        const filaValida = lista.grilla.find((fila) => {
          return (
            fila.cantidadDesde &&
            fila.cantidadHasta &&
            fila.costo &&
            item.cantidad >= fila.cantidadDesde &&
            item.cantidad <= fila.cantidadHasta
          )
        })

        return !!filaValida
      })

      const listasFormateadas = listasValidas.map((l) => {
        const filaValida = l.grilla.find((fila) => {
          return item.cantidad >= fila.cantidadDesde && item.cantidad <= fila.cantidadHasta
        })

        const filaAMostrar = filaValida || l.grilla[0] || {}

        return {
          value: `${item.idPublicacion}-${l.idLista}`,
          idLista: l.idLista,
          label: `${l.nombreLista} | ${filaAMostrar.zona} | ${filaAMostrar.cantidadDesde}-${filaAMostrar.cantidadHasta} | $${filaAMostrar.costo}`,
          nombreLista: l.nombreLista,
          zona: filaAMostrar.zona,
          cantidadDesde: filaAMostrar.cantidadDesde,
          cantidadHasta: filaAMostrar.cantidadHasta,
          precio: filaAMostrar.costo,
          grilla: l.grilla
        }
      })

      listasEnvioPorProducto[item.idPublicacion] = listasFormateadas
    }

    setListasEnvio(listasEnvioPorProducto)
  }

  const calcularListasAgrupadasPorEnvio = () => {
    const listasMap = new Map()

    vendedor.pedidoItems.forEach((item) => {
      if (idMedioEnvio[item.idPublicacion] !== ENVIO_A_CARGO_COMPRADOR) {
        return
      }

      const listasDelItem = listasEnvio[item.idPublicacion] || []
      if (listasDelItem.length > 0) {
        const listaAplicable = listasDelItem[0]
        const nombreLista = listaAplicable.nombreLista
        if (listasMap.has(nombreLista)) {
          const existente = listasMap.get(nombreLista)
          existente.cantidadTotal += item.cantidad
        } else {
          listasMap.set(nombreLista, {
            cantidadTotal: item.cantidad,
            listaInfo: listaAplicable
          })
        }
      }
    })

    return {
      listasMap,
      tieneMultiplesListas: listasMap.size > 1
    }
  }

  const debeConsultarAlVendedor = () => {
    const productosConEnvioComprador = vendedor.pedidoItems.filter(
      (item) => idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR
    )

    if (productosConEnvioComprador.length === 0) {
      return { debeConsultar: false, motivo: null }
    }

    const { listasMap, tieneMultiplesListas } = calcularListasAgrupadasPorEnvio()

    if (tieneMultiplesListas) {
      return { debeConsultar: true, motivo: 'multiplesListas' }
    }

    for (const [, info] of listasMap) {
      const cantidadTotal = info.cantidadTotal
      const listaInfo = info.listaInfo

      if (!listaInfo || !listaInfo.grilla || listaInfo.grilla.length === 0) {
        return { debeConsultar: true, motivo: 'sinGrilla' }
      }

      const filaValida = listaInfo.grilla.find((fila) => {
        return cantidadTotal >= fila.cantidadDesde && cantidadTotal <= fila.cantidadHasta
      })

      if (!filaValida) {
        return { debeConsultar: true, motivo: 'cantidadSuperaMáximo' }
      }
    }

    return { debeConsultar: false, motivo: null }
  }

  useEffect(() => {
    obtenerAdjunto()
    obtenerDomicilios(parseInt(localStorage.getItem('idUsuario')))
    obtenerMediosDePago()
    obtenerMediosEnvio()
    obtenerProvincias()
    obtenerListasEnvioDelVendedor()
  }, [])

  useEffect(() => {
    if (cuit) {
      obtenerAlicuotaPercepcion()
    }
  }, [cuit])

  const obtenerProvincias = async () => {
    const { data: provinciasAPI } = await fetchProvinciasAPI.buscarProvinciasEnEBM()
    setProvinciasAPI(provinciasAPI)
  }

  const obtenerAdjunto = async () => {
    const idTipoTYC = 8
    const { data: adjunto } = await archivoService.buscarArchivo(vendedor.idVendedor, idTipoTYC)
    const adj = URL.createObjectURL(adjunto)
    setTycfile(adj)
  }

  const obtenerDomicilios = async (idUsuario) => {
    const { data: domTemp } = await domiciliosService.buscarTodas(idUsuario, tipoUsuario)
    if (domTemp.length === 0) {
      navigate('/AdministrarDomicilios')
    } else {
      setDomicilios(domTemp)
    }
  }

  const handleClickMedioEnvio = (idMedioEnvio, idPublicacion) => {
    if (idMedioEnvio === RETIRA_COMPRADOR) {
      setDireccionEntrega((prev) => {
        const nuevo = { ...(prev || {}) }
        delete nuevo[idPublicacion]
        return nuevo
      })
    }

    setIdMedioEnvio((prev) => ({
      ...prev,
      [idPublicacion]: idMedioEnvio
    }))
    setError('')
  }

  const normalizarNombre = (provincia) =>
    (provincia ?? '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD') //Separa caracteres acentuados en 2 partes (letra base + tilde)
      .replace(/[\u0300-\u036f]/g, '') //Elmina las tildes del paso anterior
      .replace(/\./g, '') //Elimina puntos (EJ: C.A.B.A)
      .replace(/\s+/g, ' ')

  const provinciasPorNombre = useMemo(() => {
    const map = (provinciasAPI ?? []).reduce((acc, p) => {
      acc.set(normalizarNombre(p.nombre), Number(p.idProvincia))
      return acc
    }, new Map())

    ALIAS_CABA.forEach((a) => map.set(a, ID_CABA))

    return map
  }, [provinciasAPI])

  const provinciasPorId = useMemo(() => {
    const map = (provinciasAPI ?? []).reduce((acc, p) => {
      acc.set(Number(p.idProvincia), p.nombre)
      return acc
    }, new Map())
    return map
  }, [provinciasAPI])

  const handleClickDomicilioEnvio = (selected, idPublicacion) => {
    if (!selected) {
      setError('Debes seleccionar un domicilio de envío')
      return
    }
    const domicilioSeleccionado = domicilios.find((d) => d.idUsuarioDomicilio === selected.value)
    if (!domicilioSeleccionado) {
      setError('Domicilio no encontrado')
      return
    }

    const idProvinciaFinal =
      domicilioSeleccionado.idProvincia ||
      provinciasPorNombre.get(normalizarNombre(domicilioSeleccionado.provincia)) ||
      0

    setDireccionEntrega((prev) => ({
      ...prev,
      [idPublicacion]: {
        idUsuarioDomicilio: domicilioSeleccionado.idUsuarioDomicilio,
        idProvincia: idProvinciaFinal,
        provincia: domicilioSeleccionado.provincia,
        idLocalidad: domicilioSeleccionado.idLocalidad,
        localidad: domicilioSeleccionado.localidad,
        cp: domicilioSeleccionado.cp,
        calle: domicilioSeleccionado.calle,
        calleAltura: domicilioSeleccionado.calleAltura,
        piso: domicilioSeleccionado.piso,
        departamento: domicilioSeleccionado.departamento
      }
    }))

    setError('')
  }

  const handleClickListaEnvio = (lista, idPublicacion) => {
    setListaEnvioSeleccionada((prev) => ({
      ...prev,
      [idPublicacion]: lista
    }))
    setError('')
  }

  const crearPedido = async (checkoutsSeparados, conObservacion) => {
    try {
      const pedidosCreados = []

      for (const checkout of checkoutsSeparados) {
        const { checkoutDTO, percepciones: percepcionesDelPedido } = checkout
        const requiereImpuestos =
          conObservacion || (percepcionesDelPedido.length > 0 && checkout.idMedioPago !== CTA_CTE)

        const { data: rtn } = await compraService.crearPedido(checkoutDTO)

        if (rtn.idPedido > 0) {
          pedidosCreados.push(rtn)

          if (percepcionesDelPedido.length > 0) {
            await guardarPercepciones(rtn, percepcionesDelPedido)
          }
          const mail = {
            idTo: vendedor.idVendedor.toString(),
            idTipo: 2,
            param2: 'Se generó un nuevo pedido',
            param3: `${rtn.idPedido}`
          }

          if (requiereImpuestos) {
            const mensaje = {
              idMensajePadre: null,
              idPublicacion: null,
              idPedido: rtn.idPedido,
              idPresupuesto: null,
              idComprador: idUsuario,
              idVendedor: vendedor.idVendedor,
              idUsuarioChat: vendedor.idVendedor,
              texto:
                'Se generó un pedido con percepciones. Revisar el detalle de impuestos del pedido.',
              privado: true,
              idAdjunto: null
            }
            await mensajesService.insertar(mensaje)
          }
          await insertarMail(mail)
        }
      }

      if (pedidosCreados.length > 0) {
        // Eliminar carrito con todos los items
        for (const pedidoCreado of pedidosCreados) {
          await eliminarCarrito(pedidoCreado)
        }

        // Mostrar comprobante o navegar
        if (conObservacion && pedidosCreados[0]?.pedidoItems?.length > 0) {
          navigate(`/Pedido/${pedidosCreados[0].idPedido}`, {
            state: {
              mostrarModalImpuestos: true,
              pedido: checkoutsSeparados[0].checkoutDTO,
              esVentas: false,
              vieneDeCompras: true
            }
          })
        } else {
          setPedidos(pedidosCreados)
          setVerModalDatosEnvio(false)
          setVerComprobante(true)
        }
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al crear el pedido.`
      toastErrorLog(error, mensaje, 'compra')
    }
  }

  const guardarPercepciones = async (pedidoCreado, percepciones) => {
    try {
      for (const p of percepciones) {
        await impuestoService.insertar({
          idPedido: pedidoCreado.idPedido,
          idProvincia: p.idProvincia,
          tipoImpuesto: 'P',
          alicuota: p.alicuota,
          monto: p.monto,
          baseImponible: p.baseImponible
        })
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al guardar las percepciones.`
      toastErrorLog(error, mensaje, 'impuesto')
    }
  }

  const eliminarCarritoItem = async (item) => {
    try {
      const { data: carritoCantidad } = await carritoService.eliminar({
        idPublicacion: item.idPublicacion,
        idUsuario: parseInt(localStorage.getItem('idUsuario'))
      })
      setCantidad(carritoCantidad)
    } catch (error) {
      const mensaje = `Ocurrió un error al eliminar el carrito.`
      toastErrorLog(error, mensaje, 'carrito')
    }
  }

  const eliminarCarrito = async (pedido) => {
    pedido.pedidoItems.forEach((item) => {
      eliminarCarritoItem(item)
      const newItems = items.filter((i) => i.idPublicacion !== item.idPublicacion)
      setItems(newItems)
    })
  }

  const validaCampos = () => {
    const publicacionesId = vendedor.pedidoItems.map((pedido) => pedido.idPublicacion)

    const publicacionesConEnvioComprador = publicacionesId.filter(
      (id) => idMedioEnvio[id] === ENVIO_A_CARGO_COMPRADOR
    )

    if (publicacionesId.length !== Object.keys(idMedioEnvio).length) {
      return 'Debes seleccionar un medio de envío para todos los ítems'
    } else if (
      publicacionesId.filter(
        (id) => idMedioEnvio[id] === 1 || idMedioEnvio[id] === ENVIO_A_CARGO_COMPRADOR
      ).length !== Object.keys(direccionEntrega).length
    ) {
      return 'Debes seleccionar un domicilio de envío para todos los ítems'
    } else if (
      publicacionesConEnvioComprador.length > 0 &&
      publicacionesConEnvioComprador.some((id) => !listaEnvioSeleccionada[id])
    ) {
      return 'Debes seleccionar una lista de envío.'
    } else if (publicacionesId.length !== Object.keys(medioPagoSeleccionado).length) {
      return 'Debes seleccionar un medio de pago para todos los ítems'
    } else if (!chktyc) {
      return 'Para continuar debes aceptar los Términos y Condiciones del vendedor.'
    } else {
      return false
    }
  }

  const handlerContinuar = (vendedor, conObservacion = false) => {
    const error = validaCampos()
    if (error) {
      setError(error)
      return
    }

    const checkoutsSeparados = construirCheckoutsSeparados(vendedor, conObservacion)
    crearPedido(checkoutsSeparados, conObservacion)
  }

  const construirCheckoutsSeparados = (vendedor, conObservacion = false) => {
    const gruposPorMedioPago = vendedor.pedidoItems.reduce((grupos, item) => {
      const idMedioPago = Number(medioPagoSeleccionado[item.idPublicacion])
      grupos[idMedioPago] ??= []
      grupos[idMedioPago].push(item)
      return grupos
    }, {})

    const domicilioPrincipalVendedor = domiciliosVendedor.find((d) => d.domicilioPrincipal === true)

    return Object.values(gruposPorMedioPago).map((itemsDelGrupo) => {
      const totalConIvaGrupo = itemsDelGrupo.reduce(
        (total, item) => total + calcularTotalItemConIva(item),
        0
      )

      const pedidoItems = itemsDelGrupo.map((item) => {
        const esRetiraComprador = idMedioEnvio[item.idPublicacion] === RETIRA_COMPRADOR
        const domicilio = direccionEntrega[item.idPublicacion] || {}
        const listaSeleccionada = listaEnvioSeleccionada[item.idPublicacion]

        let idProvinciaFinal = domicilio.idProvincia || null
        if (esRetiraComprador && domicilioPrincipalVendedor?.provincia) {
          idProvinciaFinal =
            provinciasPorNombre.get(normalizarNombre(domicilioPrincipalVendedor.provincia)) || null
        }

        const cantidad = Number(item.cantidad)
        let precioUnitarioVisual = item.precioUnitario
        let porcDctoFinal = item.porcDcto

        if (item.valorTotalSinIva !== null && cantidad > 0) {
          precioUnitarioVisual = Number(item.valorTotalSinIva) / cantidad
          porcDctoFinal = 0
        }

        return {
          ...item,
          ...(Number(medioPagoSeleccionado[item.idPublicacion]) === CTA_CTE && {
            idPagoEstado: PAGO_EN_CTA_CTE
          }),
          idProvincia: idProvinciaFinal ? Number(idProvinciaFinal) : null,
          precioUnitario: precioUnitarioVisual,
          porcDcto: porcDctoFinal,
          entregaProvincia: domicilio.provincia || '',
          entregaLocalidad: domicilio.idLocalidad ? Number(domicilio.idLocalidad) : 0,
          entregaLocalidadDesc: domicilio.localidad || '',
          entregaCP: domicilio.cp || '',
          entregaCalle: domicilio.calle || '',
          entregaCalleAltura: domicilio.calleAltura
            ? String(domicilio.calleAltura).replace(/\D/g, '') || '0'
            : '0',
          entregaPiso: domicilio.piso || '',
          entregaDpto: domicilio.departamento || '',
          idMedioEnvio: Number(idMedioEnvio[item.idPublicacion]),
          idMedioPago: Number(medioPagoSeleccionado[item.idPublicacion]),
          precioEnvio: Number(listaSeleccionada?.precio || 0),
          total: Number(totalConIvaGrupo)
        }
      })

      const checkoutDTO = {
        ...vendedor,
        pedidoItems
      }

      const percepcionesDelPedido = calcularPercepciones(itemsDelGrupo)

      const pedidoItemsConEstadoFinal = pedidoItems.map((item) => ({
        ...item,
        idPedidoItemEstado:
          Number(item.idMedioPago) !== CTA_CTE
            ? conObservacion
              ? ID_ESTADO_PERCEPCIONES_NO_OK
              : percepcionesDelPedido.length > 0
                ? ID_ESTADO_PERCEPCIONES_OK
                : ESTADO_PAGO_PENDIENTE
            : ESTADO_PEDIDO_CREADO
      }))

      return {
        checkoutDTO: {
          ...checkoutDTO,
          pedidoItems: pedidoItemsConEstadoFinal
        },
        percepciones: percepcionesDelPedido
      }
    })
  }

  const ocultarModal = () => {
    setChktyc(null)
    setVerModalDatosEnvio(false)
    setListaEnvioSeleccionada({})
    setMedioPagoSeleccionado({})
    setDireccionEntrega({})
    setIdMedioEnvio({})
  }

  const total = vendedor.pedidoItems.reduce(
    (total, item) => total + calcularTotalItemConIva(item),
    0
  )

  const calcularCostoEnvioTotal = () => {
    const listasUnicas = new Map()

    vendedor.pedidoItems.forEach((item) => {
      const listaSeleccionada = listaEnvioSeleccionada[item.idPublicacion]

      if (!listaSeleccionada) {
        return
      }

      const idLista = listaSeleccionada.idLista || listaSeleccionada.nombreLista
      const precio = Number(listaSeleccionada.precio) || 0

      if (!listasUnicas.has(idLista) && precio > 0) {
        listasUnicas.set(idLista, precio)
      }
    })

    const precios = Array.from(listasUnicas.values())
    return precios.length > 0 ? Math.max(...precios) : 0
  }

  const costoEnvio = calcularCostoEnvioTotal()

  const totalSinIva = vendedor.pedidoItems.reduce(
    (total, item) => total + calcularTotalItemSinIva(item),
    0
  )

  const obtenerDatosFiscales = async (id) => {
    const { data } = await datosFiscalesService.buscarTodos(id)
    if (id === idUsuario) {
      setDatosFiscalesComprador(data)
    } else {
      setDatosFiscalesVendedor(data)
    }
  }

  const obtenerDomiciliosVendedor = async () => {
    const { data } = await domiciliosService.buscarTodas(vendedor.idVendedor, 'A')
    setDomiciliosVendedor(data || [])
  }

  useEffect(() => {
    obtenerDatosFiscales(idUsuario)
    obtenerDatosFiscales(vendedor.idVendedor)
    obtenerDomiciliosVendedor()
  }, [idUsuario, vendedor.idVendedor])

  const idsPublicacion = useMemo(() => {
    return (vendedor.pedidoItems ?? []).map((i) => i.idPublicacion)
  }, [vendedor.pedidoItems])

  const todosMediosEnvioSeleccionados = useMemo(() => {
    if (idsPublicacion.length === 0) {
      return false
    }
    return idsPublicacion.every((id) => idMedioEnvio[id] !== null)
  }, [idsPublicacion, idMedioEnvio])

  const calcularPercepciones = (pedidoItems) => {
    const domicilioPrincipalVendedor = domiciliosVendedor.find((d) => d.domicilioPrincipal === true)

    const itemsQueRequierenDomicilio = pedidoItems
      .map((item) => {
        const medio = idMedioEnvio?.[item.idPublicacion]

        if (medio === RETIRA_COMPRADOR && domicilioPrincipalVendedor?.provincia) {
          const idProvinciaVendedor =
            provinciasPorNombre.get(normalizarNombre(domicilioPrincipalVendedor.provincia)) || 0

          return {
            ...item,
            esRetiraComprador: true,
            provinciaVendedor: idProvinciaVendedor
          }
        }

        if (medio === ENVIO_DOMICILIO || medio === ENVIO_A_CARGO_COMPRADOR) {
          return item
        }

        return null
      })
      .filter(Boolean)

    // Provincias en donde se realiza la entrega
    const provinciasEntrega = itemsQueRequierenDomicilio.reduce((acc, item) => {
      const provincia = item.esRetiraComprador
        ? Number(item.provinciaVendedor)
        : ALIAS_CABA.includes(direccionEntrega?.[item.idPublicacion]?.localidad?.toLowerCase())
          ? ID_CABA
          : Number(direccionEntrega?.[item.idPublicacion]?.idProvincia)
      if (provincia && !acc.includes(provincia)) {
        acc.push(provincia)
      }
      return acc
    }, [])

    // Provincias donde el comprador tiene cargados datos fiscales
    const provinciasConDatosComprador = datosFiscalesComprador.reduce((acc, df) => {
      if (Number(df.idCondicionFrenteIIBB) === INSCRIPTO) {
        const provincia = Number(df.idProvincia)
        if (!acc.includes(provincia)) {
          acc.push(provincia)
        }
      }
      return acc
    }, [])

    const provinciasExentasComprador = datosFiscalesComprador.reduce((acc, df) => {
      if (Number(df.idCondicionFrenteIIBB) === EXENTO) {
        const provincia = Number(df.idProvincia)
        if (!acc.includes(provincia)) {
          acc.push(provincia)
        }
      }
      return acc
    }, [])

    //Carga la provincias en donde el vendedor es agente de percepción
    const provinciasVendedorAgente = datosFiscalesVendedor.reduce((acc, df) => {
      if (df.esAgentePercepcion === true) {
        const provincia = Number(df.idProvincia)
        if (!acc.includes(provincia)) {
          acc.push(provincia)
        }
      }
      return acc
    }, [])

    //Provincias donde se debe aplicar percepciones
    const provinciasAplicables = provinciasEntrega.filter((provincia) =>
      provinciasVendedorAgente.includes(Number(provincia))
    )

    // Item con envío a cargo del comprador
    const itemConEnvioComprador = pedidoItems.find((item) => {
      const idPublicacion = item.idPublicacion
      return (
        Number(idMedioEnvio?.[idPublicacion]) === ENVIO_A_CARGO_COMPRADOR &&
        !!listaEnvioSeleccionada?.[idPublicacion]
      )
    })

    const envioNetoUnico = itemConEnvioComprador
      ? Number(listaEnvioSeleccionada[itemConEnvioComprador.idPublicacion]?.precio) || 0
      : 0

    const percepcionesMap = new Map()

    pedidoItems.forEach((item) => {
      const itemConDomicilio = itemsQueRequierenDomicilio.find(
        (i) => i.idPublicacion === item.idPublicacion
      )

      let idProvincia
      if (itemConDomicilio?.esRetiraComprador) {
        idProvincia = Number(itemConDomicilio.provinciaVendedor)
      } else if (
        ALIAS_CABA.includes(direccionEntrega?.[item.idPublicacion]?.localidad?.toLowerCase())
      ) {
        idProvincia = ID_CABA
      } else {
        idProvincia = Number(direccionEntrega?.[item.idPublicacion]?.idProvincia)
      }

      if (!provinciasAplicables.includes(idProvincia)) {
        return
      }

      if (provinciasExentasComprador.includes(idProvincia)) {
        return
      }

      const compradorTieneDatosEnProvincia = provinciasConDatosComprador.includes(idProvincia)

      let baseImponibleItem = calcularTotalItemSinIva(item)

      if (itemConEnvioComprador?.idPublicacion === item.idPublicacion && envioNetoUnico > 0) {
        baseImponibleItem += envioNetoUnico
      }

      if (baseImponibleItem <= 0) {
        return
      }

      if (PADRONES_PROVINCIAS.includes(idProvincia)) {
        const alicuotaValida = alicuota.find(
          (a) =>
            a.idProvincia === idProvincia &&
            a.alicuotaPadron !== null &&
            !isNaN(a.alicuotaPadron) &&
            a.alicuotaPadron > 0
        )
        if (!alicuotaValida) {
          return
        }
      }

      let alicuotaFinal
      if (!compradorTieneDatosEnProvincia) {
        alicuotaFinal = ALICUOTA_MAX
      } else {
        alicuotaFinal = PADRONES_PROVINCIAS.includes(idProvincia)
          ? alicuota.find((a) => a.idProvincia === idProvincia).alicuotaPadron
          : ALICUOTA_PERCEPCION
      }

      if (percepcionesMap.has(idProvincia)) {
        percepcionesMap.get(idProvincia).baseImponible += baseImponibleItem
      } else {
        percepcionesMap.set(idProvincia, {
          idProvincia,
          nombreProvincia: provinciasPorId.get(idProvincia),
          alicuota: alicuotaFinal,
          baseImponible: baseImponibleItem
        })
      }
    })

    return Array.from(percepcionesMap.values())
      .filter((p) => p.alicuota > 0 && p.baseImponible > 0)
      .map((p) => ({
        ...p,
        monto: (p.baseImponible * p.alicuota) / 100
      }))
  }

  useEffect(() => {
    if (!todosMediosEnvioSeleccionados) {
      setPercepciones([])
      return
    }

    setPercepciones(calcularPercepciones(vendedor.pedidoItems))
  }, [
    todosMediosEnvioSeleccionados,
    idMedioEnvio,
    direccionEntrega,
    listaEnvioSeleccionada,
    datosFiscalesComprador,
    datosFiscalesVendedor,
    vendedor.pedidoItems
  ])

  const esMayorista = (item) => {
    const toNumber = (valor) => {
      const num = Number(valor)
      return Number.isFinite(num) ? num : 0
    }

    let lista = []
    if (Array.isArray(item?.preciosMayoristas) && item.preciosMayoristas.length > 0) {
      lista = item.preciosMayoristas
    } else if (Array.isArray(item?.preciosMayorista) && item.preciosMayorista.length > 0) {
      lista = item.preciosMayorista
    } else if (item?.precioUnitarioMayorista && item?.cantidadMayorista) {
      lista = [
        {
          cantidad: item.cantidadMayorista,
          precioUnitario: item.precioUnitarioMayorista
        }
      ]
    }

    const tiersValidos = lista
      .map((p) => ({
        cantidad: toNumber(p.cantidad),
        precioUnitario: toNumber(p.precioUnitario)
      }))
      .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)

    if (tiersValidos.length === 0) {
      return null
    }

    const aplicables = tiersValidos.filter((tier) => item.cantidad >= tier.cantidad)
    if (aplicables.length === 0) {
      return null
    }

    return aplicables.reduce((prev, curr) => (curr.cantidad > prev.cantidad ? curr : prev))
  }

  const valorUnitarioSinIva = (item) => {
    const mayorista = esMayorista(item)
    const toNumber = (valor) => {
      const num = Number(valor)
      return Number.isFinite(num) ? num : 0
    }

    if (mayorista) {
      return mayorista.precioUnitario
    }

    const unitario = toNumber(item.precioUnitario)
    if (unitario > 0) {
      return unitario
    }

    const totalConIva = toNumber(item.valorTotalConIva)
    const cant = toNumber(item.cantidad) || 1
    return cant > 0 ? totalConIva / cant : 0
  }

  const opciones = domicilios.map((d) => ({
    ...d,
    value: d.idUsuarioDomicilio,
    label: `${d.tipoDomicilio} - ${[d.calle, d.localidad, d.provincia]
      .filter(Boolean)
      .join(', ')}${d.domicilioPrincipal ? ' (Principal)' : ''}`
  }))

  const detallePrecioProps = {
    pedidoItems: vendedor.pedidoItems,
    valorUnitarioSinIva,
    esMayorista,
    total,
    totalSinIva,
    costoEnvio,
    porcDcto: vendedor.pedidoItems[0]?.porcDcto || 0
  }

  return verComprobante ? (
    pedidos.map((pedido) => {
      const muestraPasarela = pedido.pedidoItems.some(
        (item) => medioPagoSeleccionado[item.idPublicacion] === MERCADO_PAGO
      )

      return (
        <Comprobante
          key={pedido.idPedido}
          vendedor={vendedor}
          pedido={pedido}
          medioPago={medioPagoSeleccionado}
          muestraPasarela={muestraPasarela}
        />
      )
    })
  ) : (
    <div className="row mt-4 borde-perfil ml-auto mr-auto" key={vendedor.idVendedor}>
      <div className="col-12 text-center">
        <h3>Vendedor: {vendedor.razonSocial || vendedor.pedidoItems[0].nombre}</h3>
      </div>

      <DetallePrecio {...detallePrecioProps} usaImagen={true} />

      <div className={`${styles.continueButton} mt-5`}>
        <button
          type="button"
          className={`btn btn-volver-comprar ${styles.continueCta}`}
          id="checkout-btn"
          onClick={() => setVerModalDatosEnvio(true)}
        >
          Continuar compra
        </button>
      </div>

      <Modal show={verModalDatosEnvio} onHide={() => ocultarModal()} size={'xlg'} animation={false}>
        <form>
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Confirmá los datos de tu Envío</h3>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className={styles.modalBody}>
            <BordePrincipal titulo="Medios de pago y Entrega">
              <div className={styles.tableWrapper}>
                <table className={`table table-striped align-middle ${styles.table}`}>
                  <thead>
                    <tr>
                      <th>Ítem</th>
                      <th>Tipo de Entrega</th>
                      <th>Domicilio de Envío</th>
                      <th>Lista de Envío</th>
                      <th>Medio de Pago</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendedor.pedidoItems.map((item) => (
                      <tr key={item.idPublicacion}>
                        <td data-label="Ítem">{item.titulo}</td>

                        <td data-label="Tipo de Entrega">
                          <div className="d-flex col">
                            {mediosEnvios
                              .filter((opcion) =>
                                item.mediosEnvios.includes(opcion.value.toString())
                              )
                              .map((opcion) => (
                                <Checkbox
                                  type="radio"
                                  key={opcion.value}
                                  label={opcion.label}
                                  checked={idMedioEnvio[item.idPublicacion] === opcion.value}
                                  onChange={() =>
                                    handleClickMedioEnvio(opcion.value, item.idPublicacion)
                                  }
                                  name={`idMedioEnvio-${item.idPublicacion}`}
                                />
                              ))}
                          </div>
                        </td>

                        <td data-label="Domicilio de Envío">
                          {idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR ||
                          idMedioEnvio[item.idPublicacion] === ENVIO_DOMICILIO ? (
                            <>
                              <div
                                className={`d-flex align-items-center ${styles.domicilioWrapper}`}
                              >
                                <Select
                                  key={domicilios.length}
                                  options={opciones}
                                  value={opciones.find(
                                    (o) =>
                                      o.value ===
                                      (direccionEntrega[item.idPublicacion]?.idUsuarioDomicilio ||
                                        null)
                                  )}
                                  onChange={(selected) =>
                                    handleClickDomicilioEnvio(selected, item.idPublicacion)
                                  }
                                  isSearchable
                                  placeholder="Selecciona un domicilio"
                                  className={styles.selectWrapper}
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  styles={selectMenuPortalStyles}
                                />
                                {loginDataContext.tipoUsuario &&
                                  loginDataContext.tipoUsuario !== 'A' && (
                                    <div
                                      className={`text-primary fw-bold ${styles.addButton}`}
                                      style={{ cursor: 'pointer' }}
                                      title="Agregar nuevo domicilio"
                                      onClick={handleAbrirModalNuevoDomicilio}
                                    >
                                      +
                                    </div>
                                  )}
                              </div>
                            </>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>

                        <td data-label="Lista de Envío" style={{ minWidth: '200px' }}>
                          {idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR ? (
                            <>
                              {(() => {
                                const listasDelProducto = listasEnvio[item.idPublicacion] || []
                                const resultado = debeConsultarAlVendedor()
                                const sinListas =
                                  !listasDelProducto || listasDelProducto.length === 0

                                if (sinListas) {
                                  return (
                                    <button
                                      type="button"
                                      className="btn btn-warning btn-sm"
                                      onClick={() => navigate(`/Publicacion/${item.idPublicacion}`)}
                                      title="No hay listas de envío disponibles para la cantidad seleccionada"
                                    >
                                      Consultar al vendedor
                                      <br />
                                      <small>(Sin lista para cantidad {item.cantidad})</small>
                                    </button>
                                  )
                                }

                                if (resultado.debeConsultar) {
                                  const mensajeMotivo =
                                    resultado.motivo === 'multiplesListas'
                                      ? 'Múltiples listas en carrito'
                                      : resultado.motivo === 'cantidadSuperaMáximo'
                                        ? `Cantidad total supera máximo disponible`
                                        : 'Configuración inválida'

                                  return (
                                    <button
                                      type="button"
                                      className="btn btn-warning btn-sm"
                                      onClick={() => navigate(`/Publicacion/${item.idPublicacion}`)}
                                      title={
                                        resultado.motivo === 'multiplesListas'
                                          ? 'Los productos tienen listas de envío diferentes'
                                          : 'La cantidad total supera el máximo disponible en la lista'
                                      }
                                    >
                                      Consultar al vendedor
                                      <br />
                                      <small>({mensajeMotivo})</small>
                                    </button>
                                  )
                                }

                                return (
                                  <Select
                                    options={listasDelProducto}
                                    value={listaEnvioSeleccionada[item.idPublicacion] || null}
                                    onChange={(selected) =>
                                      handleClickListaEnvio(selected, item.idPublicacion)
                                    }
                                    isSearchable
                                    placeholder="Selecciona una lista de envío"
                                    className={styles.selectWrapper}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={selectMenuPortalStyles}
                                  />
                                )
                              })()}
                            </>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>

                        <td data-label="Medio de Pago" style={{ minWidth: '200px' }}>
                          <Select
                            options={mediosPago.filter(
                              (m) =>
                                item.mediosPagos.includes(m.value.toString()) ||
                                m.value === MERCADO_PAGO
                            )}
                            value={
                              mediosPago.find(
                                (o) =>
                                  o.value === (medioPagoSeleccionado?.[item.idPublicacion] || null)
                              ) || null
                            }
                            onChange={(selected) => {
                              const value = selected ? selected.value : null
                              setMedioPagoSeleccionado((prev) => {
                                return {
                                  ...prev,
                                  [item.idPublicacion]: value
                                }
                              })
                              setError('')
                            }}
                            placeholder="Selecciona un medio"
                            className={styles.selectWrapper}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={selectMenuPortalStyles}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <DetallePrecio
                {...detallePrecioProps}
                titulo="Detalle de pago"
                costoEnvio={costoEnvio}
                pedidoCompletoEsCtaCte={pedidoCompletoEsCtaCte}
                percepciones={percepciones}
                mensajeAdicional={
                  (vendedor.pedidoItems ?? []).some(
                    (item) =>
                      idMedioEnvio[item.idPublicacion] === ENVIO_DOMICILIO ||
                      idMedioEnvio[item.idPublicacion] === ENVIO_A_CARGO_COMPRADOR
                  ) ? (
                    <>
                      <strong>Importante:</strong> Su dirección de entrega y condiciones
                      seleccionadas deberán coincidir con los destinos y costos ofrecidos. De lo
                      contrario, el vendedor podrá <strong>rechazar</strong> el pedido.
                    </>
                  ) : null
                }
              />
            </BordePrincipal>
            <div className={`col text-center mt-4 ${styles.termsWrapper}`}>
              <Checkbox
                name="tyc"
                className="mr-2"
                type="checkbox"
                onClick={(e) => {
                  setChktyc(e.target.checked ? 'on' : null)
                  setError('')
                }}
              />
              Aceptar{' '}
              <a className="mr-2" href={tycfile} target="_blank" rel="noreferrer">
                Términos y Condiciones de Venta
              </a>
              del vendedor.
            </div>
            <div className="text-center">
              {error && <div className="text-danger mt-2">{error}</div>}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className={styles.modalFooterButtons}>
              <button
                type="button"
                className={`btn btn-enviar ${styles.footerBtn}`}
                onClick={ocultarModal}
              >
                Cancelar
              </button>
              <button
                type="button"
                className={`btn btn-volver-comprar ${styles.footerBtn}`}
                onClick={() => handlerContinuar(vendedor)}
              >
                Confirmar Operación
              </button>
              {Object.values(medioPagoSeleccionado).includes(MERCADO_PAGO) && (
                <button
                  type="button"
                  className={`btn btn-volver-comprar-observacion w-20 ${styles.footerBtn}`}
                  onClick={() => handlerContinuar(vendedor, true)}
                >
                  Confirmar Operación con observación de impuestos
                </button>
              )}
            </div>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={verModalNuevoDomicilio}
        onHide={() => setVerModalNuevoDomicilio(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Domicilio</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <FormInsertDomicilio
            domicilioPrincipal={domicilioPrincipal}
            domicilioFacturacion={domicilioFacturacion}
            onNew={handleGuardarNuevoDomicilio}
            onChangeDomicilio={handleChangeDomicilio}
            provinciasAPI={provinciasAPI}
            onCancel={() => setVerModalNuevoDomicilio(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  )
}

Vendedor.propTypes = {
  vendedor: PropTypes.shape({
    idVendedor: PropTypes.number.isRequired,
    razonSocial: PropTypes.string,
    pedidoItems: PropTypes.arrayOf(
      PropTypes.shape({
        idPublicacion: PropTypes.number.isRequired,
        titulo: PropTypes.string,
        nombre: PropTypes.string,
        cantidad: PropTypes.number,
        cantidadMayorista: PropTypes.number,
        precioUnitario: PropTypes.number,
        precioUnitarioMayorista: PropTypes.number,
        alicuota: PropTypes.number,
        monedaSimbolo: PropTypes.string,
        porcDcto: PropTypes.number
      })
    ).isRequired,
    idUsuario: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired
}
export default Vendedor
